import DayRangePicker from '../dayRangePicker/src/dayRangePicker.vue';
import moment from 'moment-timezone';
import PopupWrapper from '../popupWrapper/popupWrapper.vue';
import TimePicker from '../timePicker/src/timePicker.vue';
import Vue from 'vue';

import template from 'raw-loader!./dayRangePopup.html';

const liveOptions = {
  0: 'in progress',
  1: 'hour',
  4: '4 hours',
  24: '24 hours',
  120: '5 days',
  240: '10 days',
  720: '30 days',
};
let updateKey = 0;

function initData(isVisible, isPaused, dateRange, dialBackHours) {
    let dialBackLimit = moment().subtract((dialBackHours), 'hours');
    let now = moment();
    let startDay, endDay, startTime, endTime;
    updateKey = updateKey++;

    if (dateRange && dateRange.startDate && dateRange.startDate.isAfter(dialBackLimit)) {
      startDay = moment(dateRange.startDate);
      // mid day for precision and to match day picker
      startDay.hours(12);
      startDay.minutes(0);
      startDay.seconds(0);
      startTime = {
        hours: dateRange.startDate.hours(),
        minutes: dateRange.startDate.minutes()
      };
    } else {
      let startDay = moment(dialBackLimit);
      // mid day for precision and to match day picker
      startDay.hours(12);
      startDay.minutes(0);
      startDay.seconds(0);
      startTime = {
        hours: moment(dialBackLimit.startDate).hours(),
        minutes: moment(dialBackLimit.startDate).minutes()
      };
    }

    if (dateRange && dateRange.endDate && dateRange.endDate.isAfter(dialBackLimit)) {
      endDay = moment(dateRange.endDate);
      // mid day for precision and to match day picker
      endDay.hours(12);
      endDay.minutes(0);
      endDay.seconds(0);
      endTime = {
        hours: dateRange.endDate.hours(),
        minutes: dateRange.endDate.minutes()
      };
    } else {
      let endDay = moment(dialBackLimit);
      // mid day for precision and to match day picker
      endDay.hours(12);
      endDay.minutes(0);
      endDay.seconds(0);
      endTime = {
        hours: moment(dialBackLimit.endDate).hours(),
        minutes: moment(dialBackLimit.endDate).minutes()
      };
    }

    let activeTab = isPaused ? 'previous' : 'live';
    let liveOptionsClass = isPaused ? 'liveOptions hidden' : 'liveOptions';
    let previousTimeClass = isPaused ? 'previousTime' : 'previousTime hidden';
    let filteredOptions = _.pickBy(liveOptions, function(value, key){
      return key <= dialBackHours;
    });
    return {
      activeTab: activeTab,
      errorMessage: '',
      hasError: false,
      liveOptions: filteredOptions,
      liveOptionsClass: liveOptionsClass,
      previousTimeClass:previousTimeClass,
      dayRange: {
        startDay: startDay,
        endDay: endDay
      },
      updateKey: updateKey,
      startTime: startTime,
      endTime: endTime,
    };
}
function updateData(base, newData) {
  Object.keys(newData).forEach(function (key) {
    let value = newData[key];
    if (typeof value === 'object') {
      Object.assign(base[key], value);
    } else {
      base[key] = newData[key];
    }
  });
}

let dayRangePopup = Vue.component('dayRangePopup', {
  name: 'DayRangePopup',
  template: template,
  props: {
    isPaused: {
      type: Boolean,
      default: false
    },
    isVisible: {
      type: Boolean,
      default: false
    },
    dateRange: {
      type: Object,
      default: function() {
        return {
          startDate: undefined,
          endDate: undefined
        };
      }
    },
    dialBackHours: {
      type: Number,
      default: 720
    },
  },
  watch: {
    isVisible: function(isVisible) {
      if (isVisible) {
        let data = initData(true, this.isPaused, this.dateRange, this.dialBackHours);
        updateData(this, data);
        updateKey = updateKey++;
        this.updateKey = updateKey++;
        setTimeout(() => {
          this.$refs.headerTabs.focus();
        }, 0);
      }
    },
    dateRange: function() {
      let data = initData(this.isVisible, this.isPaused, this.dateRange, this.dialBackHours);
      updateData(this, data);
    }
  },
  data: function() {
    return initData(this.isVisible, this.isPaused, this.dateRange, this.dialBackHours);
  },
  methods: {
    applyNewDate: function() {
      let newStartDate = moment(this.dayRange.startDay);
      let newEndDate = moment(this.dayRange.endDay);
      let now = moment().add(5, 'minutes'); // pad 5 minutes to allow for server time being off
      let dialBackLimit = moment().subtract((this.dialBackHours), 'hours');
      newStartDate.hours(this.startTime.hours);
      newStartDate.minutes(this.startTime.minutes);
      newStartDate.seconds(0);
      newEndDate.hours(this.endTime.hours);
      newEndDate.minutes(this.endTime.minutes);
      newEndDate.seconds(0);
      if (newStartDate.isAfter(now)) {
        newStartDate = moment(now);
      }
      if (newEndDate.isAfter(now)) {
        newEndDate = moment(now);
      }
      if (newStartDate.isAfter(newEndDate)) {
        this.hasError = true;
        this.errorMessage = 'Start must be before end.';
      } else if(newStartDate.isBefore(dialBackLimit)) {
        const serviceLevels = {
          4: '4 hours',
          24: '24 hours',
          168: '7 days',
          240: '10 days',
          720: '30 days',
        };
        let timeText = serviceLevels[this.dialBackHours];
        if (!timeText) {
          timeText = this.dialBackHours + ' hours';
        }
        this.hasError = true;
        this.errorMessage = 'Current plan only includes last ' + timeText + ' of history.';
        let validStartTime = dialBackLimit.add(5, 'minutes');
        this.startTime = {
          hours: validStartTime.hours(),
          minutes: validStartTime.minutes(),
        }
      } else {
        this.$emit('date-range-change', {
          startDate: newStartDate,
          endDate: newEndDate,
          isLive: false
        });
        this.$emit('popup-close');
      }
    },
    handleClose: function() {
      this.$emit('popup-close');
    },
    handleStartTimeChange: function(newTime) {
      this.startTime.hours = newTime.hours;
      this.startTime.minutes = newTime.minutes;
    },
    handleEndTimeChange: function(newTime) {
      this.endTime.hours = newTime.hours;
      this.endTime.minutes = newTime.minutes;
    },
    handleDayChange: function(newDayRange) {
      this.dayRange.startDay = newDayRange.startDay;
      this.dayRange.endDay = newDayRange.endDay;
    },
    selectRange: function(hours) {
      let newEndDate = moment();
      let newStartDate = moment().subtract(hours, 'hours');
      this.$emit('date-range-change', {
        startDate: newStartDate,
        endDate: newEndDate,
        isLive: true
      });
      this.$emit('popup-close');
    },
    switchTabs: function() {
      let self = this;
      let isPaused = this.activeTab === 'live' ? true : false;
      let data = initData(this.isVisible, isPaused, this.dateRange, this.dialBackHours);
      updateData(this, data);
    },
  },
  components: {
    'day-range-picker': DayRangePicker,
    'popup-wrapper': PopupWrapper,
    'time-picker': TimePicker,
  },
});

export default dayRangePopup;
